// eslint-disable-next-line import/no-internal-modules
import { useBrowserTabVisibility } from "@rshbintech.dboul/core-ui/dist/a11y/a11y-base/hooks/use-browser-tab-visibility";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  selectDefaultTabTitle,
  selectTabTitleUpdateIntervalId,
} from "../../../modules/chat/selectors";
import { setTabTitleUpdateIntervalId } from "../../../modules/chat/actions";

export const useResetChatNotifications = () => {
  const { isBrowserTabVisible } = useBrowserTabVisibility();
  const dispatch = useAppDispatch();
  const intervalId = useAppSelector(selectTabTitleUpdateIntervalId);
  const defaultTabTitle = useAppSelector(selectDefaultTabTitle);

  useEffect(() => {
    if (isBrowserTabVisible && intervalId) {
      clearInterval(intervalId);
      dispatch(setTabTitleUpdateIntervalId(null));
      document.title = defaultTabTitle;
    }
  }, [isBrowserTabVisible, intervalId]);
};
